module.exports = __webpack_public_path__ + "static/media/connacht.a852bb9a.png";